module.exports = __webpack_public_path__ + "assets/img/icon11.fa9d53d8.png";